import React from 'react';
import CollapseAnimation from 'components/atoms/base-animations/collapse';
import { Link } from 'react-router-dom';

import s from './styles.module.scss';

import type { IDropdownLinks } from '../../types';

interface IProps {
  data: IDropdownLinks;
  opened: boolean;
  onClick: () => void;
}

const HeaderLargeLinks: React.FC<IProps> = (props) => {
  const { data, opened, onClick } = props;

  return (
    <div className={s.bigdropdownOverlay}>
      <CollapseAnimation opened={opened} duration={0.3}>
        <div className={s.bigdropdown}>
          <span className={s.name}>{data.label}</span>
          <ul>
            {data.links.map((linkGroup, index) => (
              <div
                className={s['group-wrapper']}
                key={index}
                hidden={linkGroup.length === 0}
              >
                {linkGroup.length > 0 && (
                  <div key={index} className={s.group}>
                    {linkGroup.map((link) => (
                      <div key={link.link}>
                        <Link
                          data-cy={link.dataCy}
                          to={link.link}
                          target={link.target}
                          onClick={onClick}
                        >
                          <li className={s.item}>
                            {link.label}
                            {link.showBadge && <i className={s.badge} />}
                            {link.badgeCount != null && link.badgeCount > 0 && (
                              <i
                                className={s.badge}
                                role="status"
                                aria-label={`${link.badgeCount} new`}
                              />
                            )}
                          </li>
                        </Link>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </ul>
        </div>
      </CollapseAnimation>
    </div>
  );
};
export default HeaderLargeLinks;
